import { appendAPExamTemplate } from '@/functions/idp'
import RIC from './RIC_7'

export default appendAPExamTemplate({
  ...RIC,
  aimName: 'RIC+AP'
})
